import React from 'react'
import { Text, Flex, Button, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { Icon } from '../../../../../../ui/components/Icon'
import { ErrorIcon } from './ErrorIcon'

export type ErrorProps = {
  onTryAgainClick: () => void
}

export const Error = ({ onTryAgainClick }: ErrorProps) => {
  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      className={csx({ flex: 1, transform: `translateY(-$space-8)` })}
    >
      <Flex
        direction="column"
        justify="center"
        align="center"
        className={csx({ flex: 1 })}
      >
        <Icon
          className={csx({
            width: '6.458rem',
            height: '6.458rem',
          })}
        >
          <ErrorIcon />
        </Icon>
        <Text
          variant="display"
          className={csx({
            marginTop: '2.792rem',
          })}
        >
          <FormattedMessage id="checkout.advertisements.error.title" />
        </Text>
        <Text
          variant="title2"
          tone="secondary"
          className={csx({
            marginTop: 3,
            maxWidth: '20.438rem',
            textAlign: 'center',
          })}
        >
          <FormattedMessage id="checkout.advertisements.error.subtitle" />
        </Text>
      </Flex>
      <Button
        variant="primary"
        onClick={onTryAgainClick}
        className={csx({
          width: '20.438rem',
          borderRadius: 'pill',
        })}
      >
        <FormattedMessage id="tryAgain" />
      </Button>
    </Flex>
  )
}
